export const getAuth = state => state.auth;

export const linkToNavigate = state => state.auth.linkToNavigate;
